module.exports = __webpack_public_path__ + "static/media/white-monday-puzzle-image.1a9be890.jpg";